import { h } from 'preact'
import formatDateInLocalTimezone from '@insided/shared/utils/dateFormatting'
import Icon from '../../../preact-components/assets'
import classNames from 'classnames'

const DateCell = (accessor: string, showTime: boolean = true) => {
  return (props: any) => {
    const isScheduled = props.status === 'scheduled'
    const dateFromProps = props[accessor]

    if (!dateFromProps) {
      return null
    }

    if (dateFromProps === '-') {
      return dateFromProps
    }

    let date

    try {
      date = formatDateInLocalTimezone(dateFromProps, showTime)
    } catch (e) {
      // if the date is not already a timestamp, convert it
      date = formatDateInLocalTimezone(new Date(dateFromProps).getTime() / 1000 | 0, showTime)
    }

    return (
      <div className={classNames(
        'overview__table-date',
        { 'overview__table-publish-date--scheduled': isScheduled }
      )}
      >
        {date}
        {isScheduled && <Icon
          icon='clock'
          width={16}
          height={16}
                        />}
      </div>
    )
  }
}

export default DateCell
